export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14749.6e786325.jpg";